var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('nav',{staticClass:"footer"},[_c('router-link',{attrs:{"to":"/"}},[_c('img',{attrs:{"src":require("../assets/icons/home.svg")},on:{"click":function($event){_vm.$root.modalOpen = false;}}})]),_c('burger-menu')],1)}
var staticRenderFns = []

export { render, staticRenderFns }